import { YouFirstFilesType } from './types'
import { SAVE_FILES } from './actionTypes'
import { FilesModel } from '../../requests/downloadFiles/filesModel'

const initialState: FilesModel[] = []

const youfirstFiles = (
	state: FilesModel[] = initialState,
	action: YouFirstFilesType
): FilesModel[] => {
	switch (action.type) {
		case SAVE_FILES: {
			return action.payload || initialState
		}
		default:
			return state
	}
}

export default youfirstFiles
